/**
 * Flickity RTL Patch
 * Uses Object.defineProperty to intercept window.Flickity.
 * Only wraps actual constructor functions (skips namespace objects and re-wraps).
 * Ensures any external Flickity usage also gets rightToLeft: true on RTL sites.
 * Empire.js already sets rightToLeft: true internally; this is a safety net.
 */
(function () {
  'use strict';

  if (document.documentElement.dir !== 'rtl') return;

  function wrapFlickity(OriginalFlickity) {
    if (OriginalFlickity.__rtlPatched) return OriginalFlickity;

    function RTLFlickity(element, options) {
      options = options || {};
      options.rightToLeft = true;
      return new OriginalFlickity(element, options);
    }

    RTLFlickity.__rtlPatched = true;
    RTLFlickity.prototype = OriginalFlickity.prototype;
    RTLFlickity.prototype.constructor = RTLFlickity;

    Object.keys(OriginalFlickity).forEach(function (key) {
      RTLFlickity[key] = OriginalFlickity[key];
    });

    return RTLFlickity;
  }

  var _flickity = (typeof window.Flickity === 'function') ? wrapFlickity(window.Flickity) : window.Flickity || null;

  Object.defineProperty(window, 'Flickity', {
    configurable: true,
    get: function () {
      return _flickity;
    },
    set: function (FlickityClass) {
      // Only wrap constructor functions; pass namespace objects ({}) through unchanged
      if (typeof FlickityClass === 'function') {
        _flickity = wrapFlickity(FlickityClass);
      } else {
        _flickity = FlickityClass;
      }
    }
  });
})();
